import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { CreateAdminUserRequest, User } from "../_models/user";
import { ReplaySubject } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { ApiService } from "./shared/api.service"
import { LoginRequest } from "../auth/login/login.util";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AccountService {
  authUrl = GlobalConstants.apiURL;
  private currentUserSource = new ReplaySubject<User | null>(1);

  currentUser$ = this.currentUserSource.asObservable();

  loggedIn = false;

  constructor(private apiService: ApiService, private router: Router) {}

  getUserByMail(mail: string) {
    return this.apiService.get(`${this.authUrl}authenticate/email/${mail}`);
  }

  fetchUserRegistrationStatus(email: string) {
    return this.apiService.get(
      `${this.authUrl}authenticate/email/${email}/registered`
    );
  }

  login(body: LoginRequest) {
    return this.apiService.post(this.authUrl + "authenticate/login", body).pipe(
      map((response: User) => {
        const user = response;
        if (user) {
          this.loggedIn = true;
          localStorage.setItem("user", JSON.stringify(user));
          this.currentUserSource.next(user);
        }
      })
    );
  }

  forgotPasswordMail(model: any) {
    return this.apiService.post(`${this.authUrl}password/reset`, model);
  }

  forgotPasswordNewPassword(model: any) {
    return this.apiService.post(`${this.authUrl}password`, model);
  }

  updatePassword(body: any) {
    return this.apiService.post(`${this.authUrl}password/force`, body);
  }

  createDocument(model: any) {
    return this.apiService.post(this.authUrl + "document", model);
  }

  setCurrentUser(user: User) {
    this.currentUserSource.next(user);
  }

  userRegister(model: CreateAdminUserRequest) {
    return this.apiService.post(
      this.authUrl + "authenticate/register/admin",
      model
    );
  }

  createStaffUser(model: any) {
    return this.apiService.post(
      this.authUrl + "authenticate/register/staff",
      model
    );
  }

  gymAndCoachRegister(model: any) {
    return this.apiService.post(
      this.authUrl + "authenticate/register/gym",
      model
    );
  }

  updateUser(userId: string, model: any) {
    return this.apiService.put(
      this.authUrl + "authenticate/user/" + userId,
      model
    );
  }

  uploadProfileImage(userId: string, model: any) {
    return this.apiService.putFormData(
      this.authUrl + "authenticate/user/" + userId + "/upload",
      model
    );
  }

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("staff");
    localStorage.removeItem("staffs");
    localStorage.removeItem("gym");
    localStorage.removeItem("profileTab");
    this.router.navigate(["auth/login"]);
    this.currentUserSource.next(null);
  }
}
